"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.schema = exports.publicKeyCredentialWithAssertion = exports.credentialRequestOptions = exports.publicKeyCredentialWithAttestation = exports.credentialCreationOptions = void 0;
const convert_1 = require("./convert");
// Shared by `create()` and `get()`.
const publicKeyCredentialDescriptorSchema = {
    type: (0, convert_1.required)(convert_1.copyValue),
    id: (0, convert_1.required)(convert_1.convertValue),
    transports: (0, convert_1.optional)(convert_1.copyValue),
};
const simplifiedExtensionsSchema = {
    appid: (0, convert_1.optional)(convert_1.copyValue),
    appidExclude: (0, convert_1.optional)(convert_1.copyValue),
    credProps: (0, convert_1.optional)(convert_1.copyValue),
};
const simplifiedClientExtensionResultsSchema = {
    appid: (0, convert_1.optional)(convert_1.copyValue),
    appidExclude: (0, convert_1.optional)(convert_1.copyValue),
    credProps: (0, convert_1.optional)(convert_1.copyValue),
};
// `navigator.create()` request
exports.credentialCreationOptions = {
    publicKey: (0, convert_1.required)({
        rp: (0, convert_1.required)(convert_1.copyValue),
        user: (0, convert_1.required)({
            id: (0, convert_1.required)(convert_1.convertValue),
            name: (0, convert_1.required)(convert_1.copyValue),
            displayName: (0, convert_1.required)(convert_1.copyValue),
        }),
        challenge: (0, convert_1.required)(convert_1.convertValue),
        pubKeyCredParams: (0, convert_1.required)(convert_1.copyValue),
        timeout: (0, convert_1.optional)(convert_1.copyValue),
        excludeCredentials: (0, convert_1.optional)([publicKeyCredentialDescriptorSchema]),
        authenticatorSelection: (0, convert_1.optional)(convert_1.copyValue),
        attestation: (0, convert_1.optional)(convert_1.copyValue),
        extensions: (0, convert_1.optional)(simplifiedExtensionsSchema),
    }),
    signal: (0, convert_1.optional)(convert_1.copyValue),
};
// `navigator.create()` response
exports.publicKeyCredentialWithAttestation = {
    type: (0, convert_1.required)(convert_1.copyValue),
    id: (0, convert_1.required)(convert_1.copyValue),
    rawId: (0, convert_1.required)(convert_1.convertValue),
    authenticatorAttachment: (0, convert_1.optional)(convert_1.copyValue),
    response: (0, convert_1.required)({
        clientDataJSON: (0, convert_1.required)(convert_1.convertValue),
        attestationObject: (0, convert_1.required)(convert_1.convertValue),
        transports: (0, convert_1.derived)(convert_1.copyValue, (response) => response.getTransports?.() || []),
    }),
    clientExtensionResults: (0, convert_1.derived)(simplifiedClientExtensionResultsSchema, (pkc) => pkc.getClientExtensionResults()),
};
// `navigator.get()` request
exports.credentialRequestOptions = {
    mediation: (0, convert_1.optional)(convert_1.copyValue),
    publicKey: (0, convert_1.required)({
        challenge: (0, convert_1.required)(convert_1.convertValue),
        timeout: (0, convert_1.optional)(convert_1.copyValue),
        rpId: (0, convert_1.optional)(convert_1.copyValue),
        allowCredentials: (0, convert_1.optional)([publicKeyCredentialDescriptorSchema]),
        userVerification: (0, convert_1.optional)(convert_1.copyValue),
        extensions: (0, convert_1.optional)(simplifiedExtensionsSchema),
    }),
    signal: (0, convert_1.optional)(convert_1.copyValue),
};
// `navigator.get()` response
exports.publicKeyCredentialWithAssertion = {
    type: (0, convert_1.required)(convert_1.copyValue),
    id: (0, convert_1.required)(convert_1.copyValue),
    rawId: (0, convert_1.required)(convert_1.convertValue),
    authenticatorAttachment: (0, convert_1.optional)(convert_1.copyValue),
    response: (0, convert_1.required)({
        clientDataJSON: (0, convert_1.required)(convert_1.convertValue),
        authenticatorData: (0, convert_1.required)(convert_1.convertValue),
        signature: (0, convert_1.required)(convert_1.convertValue),
        userHandle: (0, convert_1.required)(convert_1.convertValue),
    }),
    clientExtensionResults: (0, convert_1.derived)(simplifiedClientExtensionResultsSchema, (pkc) => pkc.getClientExtensionResults()),
};
exports.schema = {
    credentialCreationOptions: exports.credentialCreationOptions,
    publicKeyCredentialWithAttestation: exports.publicKeyCredentialWithAttestation,
    credentialRequestOptions: exports.credentialRequestOptions,
    publicKeyCredentialWithAssertion: exports.publicKeyCredentialWithAssertion,
};
//# sourceMappingURL=schema.js.map